import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=40b03b0f&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=40b03b0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b03b0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b03b0f')) {
      api.createRecord('40b03b0f', component.options)
    } else {
      api.reload('40b03b0f', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=40b03b0f&scoped=true&", function () {
      api.rerender('40b03b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sh7aTIf0ruUx/JS/comp/Voucher.vue"
export default component.exports